


















































import Vue from 'vue'
import AppNavigation from '../components/AppNavigation.vue'
import LogoutButton from '../components/LogoutButton.vue'
import AppLoader from '../components/AppLoader.vue'
import AccountLink from '../components/AccountLink.vue'
import AppNotifications from '../components/AppNotifications.vue'

export default Vue.extend({
  name: 'Default',
  components: {
    AppNavigation,
    AppNotifications,
    LogoutButton,
    AppLoader,
    AccountLink
  },
  props: {
    navigation: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      showDrawer: true
    }
  }
})
